import { FlipHorizontal2, SquarePen, Trash2 } from 'lucide-react';
import SelectionActionMenu from '../features/floorPlanEditor/FloorPlanWorkspace/SelectionActionMenu.jsx';
import { getDefaultFloorPlanBlockedBounds } from '../features/floorPlanEditor/FloorPlanWorkspace/useOverlayPlacement.js';

/**
 * @param {{
 *   opening: import('../lib/floorPlanDesignerState.js').DesignerOpening;
 *   anchor: { x: number; y: number };
 *   openingAngleDeg?: number;
 *   viewportRect?: { width: number; height: number } | null;
 *   disabled?: boolean;
 *   onDelete: () => void;
 *   onEdit: () => void;
 *   onFlipSwing?: () => void;
 *   onBoundsChange?: (bounds: { x: number; y: number; width: number; height: number; placement: string }) => void;
 * }} props
 */
function FloorPlanOpeningActions({
  opening,
  anchor,
  viewportRect = null,
  disabled = false,
  onDelete,
  onEdit,
  onFlipSwing,
  onBoundsChange,
}) {
  const label = opening.type === 'door' ? 'Door' : 'Window';

  const buttons = [
    {
      key: 'delete',
      title: `Delete ${label.toLowerCase()}`,
      onClick: onDelete,
      Icon: Trash2,
      disabled,
    },
    ...(opening.type === 'door' && onFlipSwing
      ? [
          {
            key: 'flip',
            title: 'Flip door swing',
            onClick: onFlipSwing,
            Icon: FlipHorizontal2,
            disabled,
          },
        ]
      : []),
    {
      key: 'edit',
      title: `Edit ${label.toLowerCase()}`,
      onClick: onEdit,
      Icon: SquarePen,
      disabled,
    },
  ];

  const blockedBounds = viewportRect
    ? getDefaultFloorPlanBlockedBounds(viewportRect.width, viewportRect.height)
    : [];

  return (
    <SelectionActionMenu
      anchor={anchor}
      actions={buttons}
      canvasBounds={viewportRect}
      blockedBounds={blockedBounds}
      ariaLabel={`${opening.type} actions`}
      onBoundsChange={onBoundsChange}
    />
  );
}

export default FloorPlanOpeningActions;
